import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1843718c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pt-1 pb-1 text-gray-900 dark:text-gray-400" }
const _hoisted_2 = { class: "text-2xl font-bold mr-2 notranslate" }
const _hoisted_3 = { class: "text-base text-gray-500 dark:text-dark-text" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = { class: "text-base mr-2 text-gray-500 dark:text-dark-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_progress_bar = _resolveComponent("base-progress-bar")!
  const _component_base_contest_day_card = _resolveComponent("base-contest-day-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.problemSearchModalStatePresenter.selectedContestList.value, (contest) => {
      return (_openBlock(), _createElementBlock("details", {
        key: contest.abbr,
        class: "my-2"
      }, [
        _createElementVNode("summary", {
          class: _normalizeClass(["hover-hand py-3 pr-4 pl-12 border rounded relative hover:shadow-md transition-shadow duration-150 hover:border-challenge dark:hover:border-challenge dark:border-dark-400 dark:text-dark-text dark:bg-dark-500", _ctx.isLightMode() ? 'arrow' : 'arrow-dark'])
        }, [
          _createElementVNode("p", null, [
            _createElementVNode("span", _hoisted_2, _toDisplayString(contest.abbr), 1),
            _createElementVNode("span", _hoisted_3, _toDisplayString(contest.numberOfProblems) + " problems ", 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.calc2digit(contest.progress)) + "% ", 1),
            _createVNode(_component_base_progress_bar, {
              colorType: "CHALLENGE",
              num: _ctx.calc2digit(contest.progress)
            }, null, 8, ["num"])
          ])
        ], 2),
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contest.days, (day) => {
            return (_openBlock(), _createBlock(_component_base_contest_day_card, {
              key: day.id,
              contestDay: day,
              onClick: id => _ctx.clickProblem(contest.largeCl, contest.middleCl, id)
            }, null, 8, ["contestDay", "onClick"]))
          }), 128))
        ])
      ]))
    }), 128))
  ]))
}